import {Component, OnInit} from '@angular/core';
import {ServiceDto} from '../../../api';
import {LayoutSharedService} from '../layout-shared.service';

@Component({
    selector: 'app-drawer-menu',
    templateUrl: './drawer-menu.component.html',
    styleUrl: './drawer-menu.component.css',
    standalone: false
})
export class DrawerMenuComponent implements OnInit {

  services!: ServiceDto[];

  constructor(private layoutSharedService: LayoutSharedService) {
  }

  ngOnInit(): void {
    this.layoutSharedService.getServices().subscribe(services => {
      this.services = services;
    })
  }
}
